<div class="relative flex-1 overflow-hidden">
  <lib-teeth
    class="mx-auto max-w-[1200px] flex-1 md:max-w-[1360px] lg:max-w-[1600px]"
    [ngClass]="{
      'pointer-events-none animate-pulse opacity-80 grayscale': loading()
    }"
    [teeth]="teethWithLayers() ?? defaultTeeth()"
    [bridges]="bridges()"
    (clicked)="onToothSelected($event)"
  />
</div>
<div class="container flex items-center justify-end">
  <div class="flex items-center gap-4">
    <!-- @if (canAddTreatment()) { -->

    <!-- TEMPORARILY REMOVE TREATMENT PLAN FEATURE -->

    <!-- <button class="btn-secondary" [disabled]="loading()" type="button" (click)="onViewTreatmentPlanClick()">
      <span class="py-[3px]">
        {{ 'charting_view_treatment_plan_button' | translate }}
      </span>
    </button> -->

    <button class="btn-primary" [disabled]="loading()" type="button" (click)="onAddTreatmentClick()">
      <span class="py-[3px]">
        {{ 'charting_add_treatment_button' | translate }}
      </span>
    </button>
    <!-- } -->
  </div>
</div>

<router-outlet></router-outlet>
